import React, { Fragment, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import Edit from "../../../assets/images/ui.svg";
import Delete from "../../../assets/images/ux.svg";
import Spinner from "../../../Components/loader";
import { connect } from 'react-redux';
import ProductForm from './productForm';
import { clearDeletePackageProductAction, deletePackageProductAction, displayCurrency, displayQuantity, role } from '../../../actions';
import { toast } from "react-toastify";
import { stripHtml } from '../../../helpers/stripHtml';


const ViewProducts = (props) => {

    const { open, id, productsList, loading, edit, reset, productItem, onDeleteProduct, onClearDeleteProduct, deleteProductResponse } = props;

    useEffect(() => {
        if (deleteProductResponse) {
            toast(deleteProductResponse.data);
            if (deleteProductResponse.status === 200) {
                // trigger the parent refresh of the package product list
                reset(true);
            }
            onClearDeleteProduct();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteProductResponse]);

    const handleDelete = (item) => {
        if (window.confirm(`Remove "${stripHtml(item?.productName)}" from this package?`)) {
            onDeleteProduct(item?.packageProductId);
        }
    };

    return (
        <Fragment>
            {open ?
                <div className="table-back-pack table-blue-bg package-products-view">
                    <Table responsive>
                        <thead>
                            <th className="pp-col-article">Article ID</th>
                            <th className="pp-col-name">Product Name</th>
                            <th className="pp-col-qty">QTY</th>
                            <th className="pp-col-price">Unit Price</th>
                            <th className="pp-col-price">Total Price</th>
                            {role === "admin" && <th className="pp-col-actions">Actions</th>}
                        </thead>
                        <tbody>
                        {productsList && productsList?.length > 0 ? productsList?.map((item, index) => {
                            return (
                                <tr key={index} >
                                    <td className="pp-col-article">{item?.articleId}</td>
                                    <td className="pp-col-name" title={stripHtml(item?.productName)}>{stripHtml(item?.productName)}</td>
                                    <td className="pp-col-qty">{displayQuantity(item?.quantity)}</td>
                                    <td className="pp-col-price">{item?.unitPrice != null ? displayCurrency(item.unitPrice) : "-"}</td>
                                    <td className="pp-col-price">{item?.totalPrice != null ? displayCurrency(item.totalPrice) : "-"}</td>
                                    {role === "admin" && <td className="pp-col-actions">
                                        <img src={Edit} alt="edit" className="Edit-staffs pkg-prod-action" onClick={() => {edit(item)}}/>
                                        <img src={Delete} alt="delete" className="Edit-staffs pkg-prod-action" onClick={() => handleDelete(item)}/>
                                    </td>}
                                </tr>
                      )
                    }) :
                      !loading ?
                        (<tr>
                             <td colSpan="6" className="pack-pos-center">
                                No Records Found
                             </td>
                         </tr>) :
                        <Spinner />
                    }
                        </tbody>
                    </Table>
                    <ProductForm reset={reset} productItem={productItem}/>
                </div> : null}
        </Fragment>
    );
}


const  mapStateToProps = (state) => {
    const {packages} = state;
    return {
        productsList: packages.productsList?.data?.packageProductResDtoList,
        loading: packages.loading,
        deleteProductResponse: packages.deletePackageProduct
    }
}

const mapDispatchToProps = (dispatch) => ({
    onDeleteProduct: (id) => dispatch(deletePackageProductAction(id)),
    onClearDeleteProduct: () => dispatch(clearDeletePackageProductAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewProducts);
